export const getStorageKey = (tournament_slug: string) => `selected_event_${tournament_slug}`;
